import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { environment as env } from '@environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

interface customerFeedback {
	id: number;
	image: string;
	mobileImage: string;
	feedback: string;
	audioSrc: string;
}

@Component({
	selector: 'app-customer-feedback',
	templateUrl: './customer-feedback.component.html',
	styleUrls: ['./customer-feedback.component.scss'],
})
export class CustomerFeedbackComponent implements OnInit {
	constructor(
		public viewport: ViewportService,
		public locale: LocaleService,
		private deviceDetectorService: DeviceDetectorService,
		private elementRef: ElementRef
	) {}

	@ViewChildren('audios') audioPlayers: QueryList<any>;
	happyCustomerData: customerFeedback[] = [
		{
			id: 1,
			image: 'assets/images/vip-plus/customer-feedback-img2.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img2mob.png',
			feedback:
				'ڕیكلامێكی زۆر باش بوو وە لە ماوەی 2 رۆژ توانیم بیفرۆشم لە بازار پارەكی زۆر كەمكتریان پێ دەدا بەلام لە رێگەی ئێوەوە توانیم یەكسەر بیفرۆشم بە نرخێكی زۆر باش',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/jeep.mp3',
		},
		{
			id: 2,
			image: 'assets/images/vip-plus/customer-feedback-img3.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img3mob.png',

			feedback: 'بصراحە إعلان جید جدا كلامكم صح بأقل وقت بیعت السیارە  بسعر مناسب ماشالله هوایە اشخاص شایفت إعلانی و هوایە ارقام منكل العراق اتصلنی ',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/mg.mp3',
		},
		{
			id: 3,
			image: 'assets/images/vip-plus/customer-feedback-img4.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img4mob.png',
			feedback:
				'سەرەتا كە بینیم ریكلامی ڤی ئای پلەس ئەو نرخەی هەیە وام هەست كرد زۆرە بەلام دواتر كە زانیم گەرەنتی سەد لە سەدی لەگەلە وە دەتوانم بیفرۆشم یەكسەر كردم و وە توانیم لە كەمترین ماوە بیفرۆشم ',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/prado.mp3',
		},
	];

	onOpenWhatsapp() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';

		window.open(env.WHATSAPP.callForHelpUrl, targetDisplay);
	}

	onCallCustomerCare() {
		window.location.href = 'tel:' + `07512347071`;
	}

	stopOtherAudios(currentAudio: HTMLAudioElement): void {
		this.audioPlayers.forEach((audio: ElementRef<HTMLAudioElement>) => {
			if (audio.nativeElement !== currentAudio) {
				audio.nativeElement.pause();
			}
		});
	}

	ngOnInit(): void {}
}
